/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_newsletter_footer_email_sent = /** @type {(inputs: {}) => string} */ () => {
	return `Vaše žádost o registraci byla přijata. Potvrzení vám bylo zasláno e-mailem.`
};

const da_newsletter_footer_email_sent = /** @type {(inputs: {}) => string} */ () => {
	return `Din tilmelding er blevet registreret. Du har modtaget en bekræftelse pr. e-mail.`
};

const de_newsletter_footer_email_sent = /** @type {(inputs: {}) => string} */ () => {
	return `Ihre Anmeldung wurde erfolgreich empfangen. Eine Bestätigung wurde per E-Mail an Sie gesendet.`
};

const en_newsletter_footer_email_sent = /** @type {(inputs: {}) => string} */ () => {
	return `Your registration request has been received. A confirmation has been sent to you by email.`
};

const es_newsletter_footer_email_sent = /** @type {(inputs: {}) => string} */ () => {
	return `Su solicitud de suscripción ha sido registrada. Se le ha enviado una confirmación por correo electrónico.`
};

const fr_newsletter_footer_email_sent = /** @type {(inputs: {}) => string} */ () => {
	return `Votre demande d'inscription a bien été prise en compte. Une confirmation vous a été envoyée par email.`
};

const hu_newsletter_footer_email_sent = /** @type {(inputs: {}) => string} */ () => {
	return `Regisztrációs kérelmét sikeresen rögzítettük. Megerősítő e-mailt küldtünk Önnek.`
};

const it_newsletter_footer_email_sent = /** @type {(inputs: {}) => string} */ () => {
	return `La tua richiesta di iscrizione è stata registrata. Ti è stata inviata una conferma via e-mail.`
};

const nl_newsletter_footer_email_sent = /** @type {(inputs: {}) => string} */ () => {
	return `Je inschrijfverzoek is in behandeling genomen. Er is een bevestiging naar je e-mailadres gestuurd.`
};

const pl_newsletter_footer_email_sent = /** @type {(inputs: {}) => string} */ () => {
	return `Twoje zgłoszenie zostało przyjęte. Potwierdzenie zostało wysłane na Twój adres e-mail.`
};

const pt_newsletter_footer_email_sent = /** @type {(inputs: {}) => string} */ () => {
	return `A sua inscrição foi recebida. Uma confirmação foi enviada por e-mail.`
};

const sv_newsletter_footer_email_sent = /** @type {(inputs: {}) => string} */ () => {
	return `Din anmälan har registrerats. En bekräftelse har skickats till dig via e-post.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const newsletter_footer_email_sent = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.newsletter_footer_email_sent(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("newsletter_footer_email_sent", locale)
	if (locale === "cs") return cs_newsletter_footer_email_sent(inputs)
	if (locale === "da") return da_newsletter_footer_email_sent(inputs)
	if (locale === "de") return de_newsletter_footer_email_sent(inputs)
	if (locale === "en") return en_newsletter_footer_email_sent(inputs)
	if (locale === "es") return es_newsletter_footer_email_sent(inputs)
	if (locale === "fr") return fr_newsletter_footer_email_sent(inputs)
	if (locale === "hu") return hu_newsletter_footer_email_sent(inputs)
	if (locale === "it") return it_newsletter_footer_email_sent(inputs)
	if (locale === "nl") return nl_newsletter_footer_email_sent(inputs)
	if (locale === "pl") return pl_newsletter_footer_email_sent(inputs)
	if (locale === "pt") return pt_newsletter_footer_email_sent(inputs)
	return sv_newsletter_footer_email_sent(inputs)
};
export { newsletter_footer_email_sent as "newsletter.footer.email_sent" }